import { render, staticRenderFns } from "./CertificationView.vue?vue&type=template&id=ef9c81ee&scoped=true"
import script from "./CertificationView.vue?vue&type=script&lang=js"
export * from "./CertificationView.vue?vue&type=script&lang=js"
import style0 from "./CertificationView.vue?vue&type=style&index=0&id=ef9c81ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9c81ee",
  null
  
)

export default component.exports